/**
 * DKM-5193 Cedric: Destek talebine eklenecek "ekranda alınan son hatalar" (Helpdesk Faz 2).
 * Kayıtlar ekranHataKaydi tamponundan gelir ve zaten maskelidir (TCKN/VKN, e-posta, telefon, token → ***).
 * İki biçim üretilir: Bilgi İşlem'in zaman çizelgesinde gördüğü kısa özet (dahili not, ≤1000 karakter) ve
 * tam liste (hata-kaydi.json).
 */
import { EkranHataKaydi, EkranHataKaydiDeposu } from '../../services/ekran-hata-kaydi';

const OZET_SINIR = 1000;

function saat(z: Date): string {
  const iki = (n: number) => (n < 10 ? '0' : '') + n;
  return iki(z.getHours()) + ':' + iki(z.getMinutes()) + ':' + iki(z.getSeconds());
}

/** Dahili not metni: "Talep açılırken ekranda alınan son hatalar (N) - Ekran: X" + satır başına bir hata. DB karakter seti (ISO-8859-9) — ve … içermez, yalnız ASCII ayraç. */
export function hataOzeti(kayitlar: EkranHataKaydi[], ekranAd?: string | null): string {
  const bas = `Talep açılırken ekranda alınan son hatalar (${kayitlar.length})` + (ekranAd ? ` - Ekran: ${ekranAd}` : '') + ':';
  let metin = bas;
  for (const k of kayitlar) {
    const ust = [
      saat(k.zaman),
      k.durum !== undefined ? String(k.durum) : '',
      [k.yontem, k.url ? EkranHataKaydiDeposu.kisaAdres(k.url) : ''].filter(Boolean).join(' '),
    ]
      .filter(Boolean)
      .join(' · ');
    const govde = (k.gosterilen || k.mesaj || '').replace(/\s+/g, ' ').trim();
    // dtokgoz 16.10: eski hâli — kaynak satırı yoktu
    // const satir = ('\n- ' + ust + (govde ? ' - ' + (govde.length > 160 ? govde.slice(0, 160) + '...' : govde) : ''))
    const kaynak = kaynakMetni(k);
    const kayit = kayitMetni(k); // dtokgoz 17.10
    const satir = (
      '\n- ' +
      ust +
      (govde ? ' - ' + (govde.length > 160 ? govde.slice(0, 160) + '...' : govde) : '') +
      (kayit ? '\n  Kayıt: ' + kayit : '') +
      (kaynak ? '\n  Kaynak: ' + kaynak : '')
    )
      .replace(/…/g, '...') // kisaAdres 'x/…/y' üretir
      .replace(/[–—]/g, '-');
    if (metin.length + satir.length > OZET_SINIR - 40) {
      metin += '\n(tam liste: hata-kaydi.json)';
      break;
    }
    metin += satir;
  }
  return metin.length > OZET_SINIR ? metin.slice(0, OZET_SINIR) : metin;
}

/**
 * dtokgoz 16.10: hatanın kaynağı tek satır — "düğme: Kps Güncelle; servis: POST gen/…/KisiKaydet; metot: kpsGuncelle".
 * Servis yalnız 'ekran' kaydında dolu (http/odata kaydının adresi zaten üst satırda).
 */
export function kaynakMetni(k: EkranHataKaydi): string {
  const parca: string[] = [];
  if (k.islem) {
    parca.push('düğme: ' + k.islem);
  }
  if (k.sonIstek) {
    const bosluk = k.sonIstek.indexOf(' ');
    const yontem = bosluk > 0 && /^[A-Z]+$/.test(k.sonIstek.slice(0, bosluk)) ? k.sonIstek.slice(0, bosluk) : '';
    const adres = yontem ? k.sonIstek.slice(bosluk + 1) : k.sonIstek;
    parca.push('servis: ' + [yontem, EkranHataKaydiDeposu.kisaAdres(adres)].filter(Boolean).join(' '));
  }
  if (k.cagiran && k.cagiran.length) {
    parca.push('metot: ' + k.cagiran.join(' < '));
  }
  return parca.join('; ');
}

/**
 * dtokgoz 17.10: hatanın alındığı kayıt tek satır — "Kişi Detay - TURAN DUMAN · GenKisiForm Kod 14 · SicilKod 14".
 */
export function kayitMetni(k: EkranHataKaydi): string {
  const r = k.kayit;
  if (!r) {
    return '';
  }
  const parca: string[] = [];
  if (r.baslik) {
    parca.push(r.baslik);
  }
  const formKod = [r.form, r.kod ? 'Kod ' + r.kod : ''].filter(Boolean).join(' ');
  if (formKod) {
    parca.push(formKod);
  }
  for (const ad of Object.keys(r.alanlar || {})) {
    parca.push(ad + ' ' + (r.alanlar as any)[ad]);
  }
  return parca.join(' · ');
}

/** hata-kaydi.json içeriği (kayıtlar en yeniden eskiye). */
export function hataEkiJson(kayitlar: EkranHataKaydi[], ekranAd?: string | null): string {
  let sayfa = '';
  let tarayici = '';
  try {
    sayfa = (location.pathname || '') + (location.hash ? location.hash.split('?')[0] : '');
    tarayici = navigator.userAgent || '';
  } catch {
    /* tarayıcı dışı */
  }
  return JSON.stringify(
    {
      // dtokgoz 16.10: 2 = islem/sonIstek/cagiran alanları eklendi; 17.10: kayit (aynı sürümde, henüz yayımlanmadı)
      surum: 2,
      olusturma: new Date().toISOString(),
      ekran: ekranAd || null,
      sayfa,
      tarayici,
      hatalar: kayitlar.map((k) => ({
        no: k.no,
        zaman: k.zaman instanceof Date ? k.zaman.toISOString() : k.zaman,
        sekme: k.sekme,
        kaynak: k.kaynak,
        yontem: k.yontem,
        url: k.url,
        durum: k.durum,
        sureMs: k.sureMs,
        mesaj: k.mesaj,
        baslik: k.baslik,
        gosterilen: k.gosterilen,
        islem: k.islem,
        sonIstek: k.sonIstek,
        cagiran: k.cagiran,
        kayit: k.kayit, // dtokgoz 17.10
      })),
    },
    null,
    2
  );
}

/** UTF-8 metni base64'e çevirir (btoa yalnız Latin-1 kabul eder). */
export function utf8Base64(metin: string): string {
  const bayt = new TextEncoder().encode(metin);
  let ikili = '';
  for (let i = 0; i < bayt.length; i += 0x8000) {
    ikili += String.fromCharCode.apply(null, Array.from(bayt.subarray(i, i + 0x8000)));
  }
  return btoa(ikili);
}
